export const ID_TYPE = Object.freeze({
  ADHAAR_CARD: "Aadhaar Card",
  DRIVING_LICENSE: "Driving License",
  PASSPORT: "Passport",
  BANK_PASSBOOK: "Bank Passbook",
  VOTER_ID: "Voter ID",
  NATIONAL_ID_CARD_NUMBER: "National ID Card"
});
